import { createFileRoute } from "@tanstack/react-router";
import TmsBocaRaton from "@/pages/local/TmsBocaRaton";
export const Route = createFileRoute("/tms-boca-raton")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "TMS Boca Raton | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "TMS therapy for patients near Boca Raton, FL. SAINT TMS, standard TMS, and SPRAVATO at Neuro Wellness TMS in Coral Springs. Free benefits verification.",
        },
        {
          property: "og:title",
          content: "TMS Boca Raton | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "TMS therapy for patients near Boca Raton, FL. SAINT TMS, standard TMS, and SPRAVATO at Neuro Wellness TMS in Coral Springs. Free benefits verification.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/tms-boca-raton",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/tms-boca-raton",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <TmsBocaRaton />;
}
